/* Nikura new mobile menu: £2 Tuesdays promo card GA4 events on the standard reusable fields.
   mobile_nav_promo_click  {location_id, click_text, link_url, element_position}  tap on the £2 Tuesdays card
   mobile_nav_promo_swipe  {location_id, click_text, element_position}            swipe of the promo strip
     click_text = 'right' (moved to a later card) or 'left' (an earlier card); element_position = card now in view.
   Strict no-op unless the Convert-revealed .new-mobile-nav shows the £2 Tuesdays card (it is rendered with
   class "hidden" on every day except Tuesday). */
(function () {
  if (window.__nkMobileNavPromo) return;
  window.__nkMobileNavPromo = true;

  var TUESDAY_HREF = '/collections/2-tuesdays';
  var TUESDAY_NAME = '£2 Tuesdays is back!';

  function push(o) {
    o.location_id = 'mobile_nav';
    (window.dataLayer = window.dataLayer || []).push(o);
  }
  function visibleCards(strip) {
    return Array.prototype.filter.call(strip.children, function (c) {
      return c.classList && c.classList.contains('new-mobile-nav__banner') && !c.classList.contains('hidden');
    });
  }
  function tuesdayCard(strip) {
    var cards = visibleCards(strip);
    for (var i = 0; i < cards.length; i++) {
      var a = cards[i].querySelector('a');
      if (a && (a.getAttribute('href') || '').indexOf(TUESDAY_HREF) === 0) return cards[i];
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('.new-mobile-nav')) return;
    var card = t.closest('.new-mobile-nav__banner');
    if (!card || card.classList.contains('hidden')) return;
    var strip = card.parentElement;
    if (!strip || tuesdayCard(strip) !== card) return;
    var a = card.querySelector('a');
    push({ event: 'mobile_nav_promo_click', click_text: TUESDAY_NAME,
           link_url: a ? a.getAttribute('href') : TUESDAY_HREF,
           element_position: visibleCards(strip).indexOf(card) + 1 });
  }, true);

  var timer = null, lastIndex = {};
  function cardInView(strip) {
    var cards = visibleCards(strip), box = strip.getBoundingClientRect(), best = 0, bestGap = Infinity;
    for (var i = 0; i < cards.length; i++) {
      var gap = Math.abs(cards[i].getBoundingClientRect().left - box.left);
      if (gap < bestGap) { bestGap = gap; best = i; }
    }
    return best + 1;
  }
  document.addEventListener('scroll', function (e) {
    var strip = e.target;
    if (!strip || !strip.classList || !strip.classList.contains('new-mobile-nav__banners')) return;
    if (!tuesdayCard(strip)) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var now = cardInView(strip), before = lastIndex.value || 1;
      if (now === before) return;
      lastIndex.value = now;
      push({ event: 'mobile_nav_promo_swipe', click_text: now > before ? 'right' : 'left', element_position: now });
    }, 200);
  }, true);
})();
